import { makeStyles } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 16,
    color: '#727B8C'
  }
}))

const OralHygieneEmptyState = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return <div className={classes.root}>{t('pages.oralHygieneReport.patientsList.emptyState')}</div>
}

export default OralHygieneEmptyState
